export default (urlParameters) => {
  return {
    access_level: 0,
    can_ads_toggle: 'false',
    default_ads_toggle_state: 1,
    default_profile_id: null,
    dfp_pa: null,
    dsatUser: null,
    favorites_sort_order: null,
    first_time_user: null,
    member_level: null,
    member_level_name: null,
    messages: '[]',
    non_trial_member_level: null,
    non_trial_member_level_name: null,
    primary_activity: null,
    show_ads: null,
    show_ads_toggle: null,
    show_nc_wind_toggle: null,
    sort_order: null,
    upgrade_available: null,
    user_signed_in: null,
    user_tips: null,
    wf_username: null,
    settings: {
      units_wind: 'mph',
      units_temp: 'f',
      units_distance: 'mi',
      units_precip: 'in'
    }
  }
}